/**
 * Format a number and return a string based on input settings
 *
 * @param {Number} number The input number to format
 * @param {Number} decimals The amount of decimals
 * @param {String} decimalPoint The decimal point
 * @param {String} thousandsSep The thousands separator
 */
window.number_format = function (number, decimals = 2, decimalPoint = ',', thousandsSep = '.') {
    // Strip all characters but numerical ones.
    number         = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n          = !isFinite(+number) ? 0 : +number,
        prec       = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep        = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep,
        dec        = (typeof decimalPoint === 'undefined') ? '.' : decimalPoint,
        s          = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s              = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

/**
 * Format a date
 *
 * @param {String} date   The date to format
 * @param {String} originalFormat The original format of date
 * @param {String} format The format to set
 *
 * @returns {String} Based on input settings
 */
window.date_format = function (date, originalFormat = "DD-MM-YYYY h:mm:ss.a", format = "DD/MM/YYYY") {
    return moment(date, originalFormat).format(format);
}

/**
 * Parses qoutes of a string
 *
 * @param {String} str The string to parse
 *
 * @returns {String} The parsed string
 */
window.parseQuotes = function (str) {
    return str.replace(/[\u2018\u2019]/g, '\'').replace(/[\u201C\u201D]/g, '\"');
}

/**
 * Convert all applicable characters to HTML entities
 *
 * @param {String} str The string to convert
 *
 * @returns {String} The converted string
 */
window.htmlEntities = function (str) {
    return str.replace(/[\u00A0-\u9999<>\&]/g, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
    });
}


/**
 * Pascal Case
 *
 * Convierte un string en Pascal Case
 *
 * @param      {string}  string   The string to convert
 */
window.pascalCase = function (string) {
    let camelString = camelCase(string);
    return camelString.charAt(0).toUpperCase() + camelString.slice(1);
};

/**
 * Camel Case
 *
 * Convierte un string en Camel Case
 *
 * @param      {string}  string   The string to convert
 */
window.camelCase = function (string) {
    return string.replace(/[\s_\-](\w)/g, function (_, firstChar) {
        return firstChar.toUpperCase();
    });
};

/**
 * Kebab Case
 *
 * Convierte un string en Kebab Case
 *
 * @param {string} string The string to convert
 */
window.kebabCase = function (string) {
    return string
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s]/g, '')
        .trim()
        .replace(/\s+/g, '-');
}

/**
 * ucwords php
 *
 * Idem Camel Case
 *
 * Converts the first character of each word in a string to uppercase
 *
 * @param      {string}  strin   The string to convert
 */
window.ucwords = function (strin) {
    strin.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });
};

/**
 * ucfirst php
 *
 * Convert the first character of a string to uppercase
 *
 * @param      {string}  strin   The string to convert
 */
window.ucfirst = function (strin) {
    return strin.charAt(0).toUpperCase() + strin.slice(1).toLowerCase();
};
